import React from 'react';
import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

import { useTimeModal } from '../TimeModal/TimeModalContext';
import { formatNull, formatDate } from '../../Utils/GlobalUtils';

import LoadingLines from '../LoadingLines';
import Loading from '../Loading';
import WarningPanel from '../WarningPanel';

import Modal from '../Modal';
import EditDisciplinaryCommittee from './Components/EditDisciplinaryCommittee';

import ButtonWithConfirmation from '../ButtonWithConfirmation';

import IconContainer from '../IconContainer';
import { ReactComponent as PenIcon } from '../../icons/pen.svg';
import { ReactComponent as TrashIcon } from '../../icons/trash.svg';
import { ReactComponent as ReloadIcon } from '../../icons/reload.svg';

const DisciplinaryCommittee = ({ userId }) => {
  const { openTimeModal } = useTimeModal();

  const [cases, setCases] = React.useState([]);

  const [warning, setWarning] = React.useState('');
  const [reload, setReload] = React.useState(true);
  const [loading, setLoading] = React.useState(true);

  const [isAdmin, setIsAdmin] = React.useState(false);

  React.useEffect(() => {
      const token = localStorage.getItem('token');
  
      try {
          const decodedToken = jwtDecode(token);
          if (decodedToken.role==='АппаратСРО') {
            setIsAdmin(true);
          } else {
            setIsAdmin(false);
          }
      } catch (error) {
          console.error('Ошибка при декодировании токена: ', error);
      }
  }, []);

  React.useEffect(() => {
    const token = localStorage.getItem('token');

    setLoading(true);

    axios.get(`/api/get-user-disciplinaries?id=${userId}`)
    .then((response) => {
      setWarning('');
      setCases(response.data);
    })
    .catch((error) => {
      setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
    })
    .finally(() => {
      setReload(false);
      setLoading(false);
    });
  }, [reload, userId]);

  const deleteEntry = (id) => {
    const token = localStorage.getItem('token');

    axios.delete('/api/delete-disciplinaries', {
      data: { id },
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
    .then(() => {
      openTimeModal('Запись удалена', 'success');
      setReload(true);
    })
    .catch((error) => {
      openTimeModal(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`, 'error');
    })
    .finally(() => {
      setLoading(false);
    });
  };

  const [isEditModal, setIsEditModal] = React.useState(false);

  const [currentId, setCurrentId] = React.useState('');
  const [currentAction, setCurrentAction] = React.useState('');

  const openSuperModal = (id, action) => {
    setCurrentId(id);
    setCurrentAction(action);
    setIsEditModal(true);
  };


  return (
    <>
      <Modal isOpen={isEditModal} closeModal={() => setIsEditModal(false)}>
          <EditDisciplinaryCommittee id={currentId} action={currentAction} userId={userId} onSuccess={() => setReload(true)} />
      </Modal>

      <div className='tableContainer'>
        <div className='tableHeaderWrapper'>
          <div className='tableStatus'>
              {isAdmin ? 
              <button type='button' className='secondaryButton' onClick={() => {openSuperModal('', 'add')}}>
                <svg viewBox="0 0 24 24" id="plus" fill="currentColor">
                  <path d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"></path>
                </svg>
                Добавить
              </button>
              :
              <div></div>}
              <a className='lastUpdateWrapper'>
                  {loading ? 
                      <Loading type='inline' /> 
                  : 
                      <IconContainer Icon={ReloadIcon} onClick={() => setReload(true)} size = '14' color = 'black' className = '' />
                  }
              </a>
          </div>
          <div className='tableHeader' style={{ gridTemplateColumns: '10fr 10fr 10fr 10fr 6fr' }}>
              <div>Основание</div>
              <div>Дата решения</div>
              <div>Мера воздействия</div>
              <div>Действия</div>
              <div></div>
          </div>
        </div>
        {loading ? <LoadingLines /> 
        : warning ? <WarningPanel text={warning} inTable={true} buttonText='Обновить' buttonAction={() => setReload(true)} />
        : cases.map((caseItem) => (
            <div 
              className='tableRow nonActive' 
              style={{ gridTemplateColumns: '10fr 10fr 10fr 10fr 6fr' }}
              key={caseItem.id} 
            >
              <div>{formatNull(caseItem.ground)}</div>
              <div>{(formatDate(caseItem.decision_date))}</div>
              <div>{(formatNull(caseItem.influence_measure))}</div>
              <div>{(formatNull(caseItem.actions))}</div>
              <div style={{alignItems: 'end'}}>
                  <div className='horizontalCell'>
                    {isAdmin &&
                    <>
                      <IconContainer Icon={PenIcon} onClick={() => {openSuperModal(caseItem.id, 'change')}} size = '17' color = 'blue' className = '' />
                      <ButtonWithConfirmation 
                          entryFunc={() => {deleteEntry(caseItem.id)}} 
                          Icon={TrashIcon} 
                          IconSize={17}
                          buttonName='Удалить' 
                          color='red' 
                      />
                    </>}
                  </div>
              </div>
            </div>
        ))}
      </div>
    </>
  )
}

export default DisciplinaryCommittee;